module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution1_2-8c388e4c949ef2f1294a704369ee49cb.png";